'use client'

// TODO(Phase 5): wire to a Zod-validated server action that persists the lead

import { useState } from 'react'
import { cn } from '@/lib/cn'

const fieldBase =
  'font-body text-[15px] px-[15px] py-[13px] border-2 border-ink rounded-[11px] bg-paper2 text-ink transition-[box-shadow,background] duration-150 focus:outline-none focus:bg-white focus:shadow-[3px_3px_0_var(--color-coral)] w-full'

export function ContactForm() {
  const [submitted, setSubmitted] = useState(false)

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    setSubmitted(true)
  }

  return (
    <form
      id="cform"
      onSubmit={handleSubmit}
      className="rounded-[24px] border-2 border-ink bg-white p-[38px] shadow-[8px_8px_0_var(--color-ink)] max-[640px]:p-7"
    >
      {/* Row 1: Name + Email */}
      <div className="mb-0 grid grid-cols-2 gap-[18px] max-[640px]:grid-cols-1">
        <div className="mb-[18px] flex flex-col gap-[7px]">
          <label
            htmlFor="cf-name"
            className="font-mono text-[12px] font-bold uppercase tracking-[0.04em] text-ink"
          >
            Name
          </label>
          <input
            id="cf-name"
            type="text"
            name="name"
            placeholder="Jane Founder"
            required
            className={fieldBase}
          />
        </div>
        <div className="mb-[18px] flex flex-col gap-[7px]">
          <label
            htmlFor="cf-email"
            className="font-mono text-[12px] font-bold uppercase tracking-[0.04em] text-ink"
          >
            Email
          </label>
          <input
            id="cf-email"
            type="email"
            name="email"
            placeholder="jane@company.com"
            required
            className={fieldBase}
          />
        </div>
      </div>

      {/* Row 2: Company + Budget */}
      <div className="mb-0 grid grid-cols-2 gap-[18px] max-[640px]:grid-cols-1">
        <div className="mb-[18px] flex flex-col gap-[7px]">
          <label
            htmlFor="cf-company"
            className="font-mono text-[12px] font-bold uppercase tracking-[0.04em] text-ink"
          >
            Company
          </label>
          <input
            id="cf-company"
            type="text"
            name="company"
            placeholder="Company name"
            className={fieldBase}
          />
        </div>
        <div className="mb-[18px] flex flex-col gap-[7px]">
          <label
            htmlFor="cf-budget"
            className="font-mono text-[12px] font-bold uppercase tracking-[0.04em] text-ink"
          >
            Budget range
          </label>
          <select id="cf-budget" name="budget" className={fieldBase}>
            <option>Not sure yet</option>
            <option>Under $10k</option>
            <option>$10k–$25k</option>
            <option>$25k–$75k</option>
            <option>$75k+</option>
          </select>
        </div>
      </div>

      {/* What do you need? */}
      <div className="mb-[18px] flex flex-col gap-[7px]">
        <label
          htmlFor="cf-type"
          className="font-mono text-[12px] font-bold uppercase tracking-[0.04em] text-ink"
        >
          What do you need?
        </label>
        <select id="cf-type" name="type" className={fieldBase}>
          <option>An MVP</option>
          <option>AI product / integration</option>
          <option>Mobile app</option>
          <option>Web app</option>
          <option>SaaS platform</option>
          <option>A dedicated team</option>
          <option>Something else</option>
        </select>
      </div>

      {/* Message */}
      <div className="mb-[18px] flex flex-col gap-[7px]">
        <label
          htmlFor="cf-message"
          className="font-mono text-[12px] font-bold uppercase tracking-[0.04em] text-ink"
        >
          Tell us about the project
        </label>
        <textarea
          id="cf-message"
          name="message"
          placeholder="What are you building, who's it for, and what's the timeline?"
          className={cn(fieldBase, 'min-h-[120px] resize-y')}
        />
      </div>

      {/* Screen-reader live region — announced on submit */}
      <p role="status" aria-live="polite" className="sr-only">
        {submitted ? 'Thanks — we’ll be in touch ✓' : ''}
      </p>

      {/* Submit */}
      <button
        type="submit"
        className={cn(
          'flex w-full cursor-pointer items-center justify-center gap-[9px] rounded-[14px] border-2 border-ink px-7 py-[15px] font-display text-base font-semibold transition-[transform,box-shadow,background] duration-200',
          submitted
            ? 'bg-[#1F9D6B] text-white shadow-[4px_4px_0_var(--color-ink)]'
            : 'bg-coral text-ink shadow-[4px_4px_0_var(--color-ink)] hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-[6px_6px_0_var(--color-ink)] active:translate-x-0.5 active:translate-y-0.5 active:shadow-[1px_1px_0_var(--color-ink)]',
        )}
      >
        {submitted ? (
          'Thanks — we’ll be in touch ✓'
        ) : (
          <>
            Send it over <span aria-hidden="true">→</span>
          </>
        )}
      </button>

      {/* Note */}
      <p className="mt-[6px] font-mono text-[13px] text-muted">
        This demo form doesn&apos;t send yet — connect it to your email or a form service (Formspree, Basin) before
        launch. Or email us directly.
      </p>
    </form>
  )
}
